
export interface SubscriptionPlan {
    id: number;
    appleProductId?: string;
    googleBasePlanId?: string;
    tier: SubscriptionTierEnum;
    duration: SubscriptionDurationEnum;
}
export interface UpsertSubscriptionPlan {
    id?: number;
    appleProductId?: string;
    googleBasePlanId?: string;
    tier?: SubscriptionTierEnum;
    duration?: SubscriptionDurationEnum;
}

export interface SubscriptionPlanGrantRequest {
    userId: number;
    planId: number;
}

export enum SubscriptionTierEnum
{
    Premium = 1,
}
export const SubscriptionTierList = [
    {value: 1, label: "Premium"},
];

export enum SubscriptionDurationEnum
{
    OneWeek = 1,
    OneMonth = 2,
    ThreeMonths = 3,
    SixMonths = 4,
    OneYear = 5,
}
export const SubscriptionDurationList = [
    {value: 1, label: "One Week"},
    {value: 2, label: "One Month"},
    {value: 3, label: "Three Months"},
    {value: 4, label: "Six Months"},
    {value: 5, label: "One Year"},
];